const isIanaTimeZone = (zone: string): boolean => {
  if (!zone || zone === "auto" || zone === "Etc/Unknown") return false;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: zone });
    return true;
  } catch {
    return false;
  }
};

/** The browser's IANA time zone (e.g. "Europe/Prague"), or null when it can't be determined. */
export const detectBrowserTimeZone = (): string | null => {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return isIanaTimeZone(zone) ? zone : null;
  } catch {
    return null;
  }
};
